import styled from 'styled-components';

export const MoreItemsMessageS = styled.p`
  text-align: center;
`;
